import {Outlet, createFileRoute} from "@tanstack/react-router";

import {routeMessages} from "../../../../messages/routes.messages";

export const Route = createFileRoute("/_app/sales/offers")({
  component: () => <Outlet />,
  staticData: {
    meta: {
      labelDescriptor: routeMessages.offers,
      moduleDescriptor: routeMessages.sales,
      nav: {order: 4, visible: true},
    },
  },
});
